import React from "react";
import { Button, List, Modal, Segment, Table } from "semantic-ui-react";

// This should be it's own file?
const TableExamplePagination = (subscriptions) => (
  <Table celled unstackable>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Region</Table.HeaderCell>
        <Table.HeaderCell>Collection</Table.HeaderCell>
        <Table.HeaderCell>Column Set</Table.HeaderCell>
        <Table.HeaderCell>Start date</Table.HeaderCell>
        <Table.HeaderCell>End date</Table.HeaderCell>
        <Table.HeaderCell>Enabled</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
      {subscriptions.map((s, i) => (
        <Table.Row key={i}>
          <Table.Cell>
            {s.name}, {s.state}
          </Table.Cell>
          <Table.Cell>{s.collection}</Table.Cell>
          <Table.Cell>{s.column_set}</Table.Cell>
          <Table.Cell>{s.start_date}</Table.Cell>
          <Table.Cell>{s.end_date}</Table.Cell>
          <Table.Cell>true</Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  </Table>
);

function AccountInfo({ userInfo }) {
  const trial_until = userInfo.account.trial_until;
  const trial_message = "Trial ends: " + trial_until;
  const content = (
    <Segment padded="very">
      <List>
        <List.Item icon="user" content={userInfo.user.email} />
        <List.Item icon="key" content={"altosintel_" + userInfo.user.api_key} />
        {trial_until ? (
          <List.Item icon="wait" content={trial_message} />
        ) : (
          <></>
        )}
      </List>
      {TableExamplePagination(userInfo.subscriptions)}
    </Segment>
  );

  return (
    <Modal
      trigger={<Button className="item">{userInfo.user.email}</Button>}
      header="Account Information"
      content={content}
    />
  );
}

export default AccountInfo;
